import CM from "../../../../model/system/CM";
import BaseComponent from "../../../../../lib/components/BaseComponent";
import './LoginForm.css';
import RequestPasswordResetDialog from "../../../components/passwordReset/RequestPasswordResetDialog";
import {ChevronRight} from "react-feather";
import {toast} from "react-toastify";
import Authenticate from "../../../../../lib/model/service/oauth/dto/Authenticate";
import HCaptcha from "@hcaptcha/react-hcaptcha";
import {createRef} from "react";
import InputText from "../../../components/inputFields/InputText";
import {Card, CardContent, IconButton} from "@mui/material";
import Button from "../../../components/buttons/Button";

class LoginForm extends BaseComponent {

  constructor(props) {
    super(props);
    this.state = {
      hCaptcha: null, resetPasswordDialogOpen: false
    }
    this.captchaToken = null;
    this.hCaptchaRef = createRef();
  }

  doOAuthAuthenticationRequest(e) {
    let self = this;
    let login = document.getElementById('login').value;
    let password = document.getElementById('password').value;

    if (login !== '' && password !== '') {
      CM.get().doJsonAjax(CM.get().getServiceUrl('oauth'), new Authenticate(login, password, this.captchaToken),
        function(response) {
          if (response.success) {
            if (response.data !== null) {
              CM.get().setSessionValue('oauth_token', response.data.token, 'oauth');
              CM.get().setRoute('/cner');
            }
          } else {
            if (response.data.useCaptcha) {
              if (self.hCaptchaRef.current === null) {
                self.state.hCaptcha =
                  <HCaptcha ref={self.hCaptchaRef} sitekey={CM.get().getHCaptchaSiteKey()} onVerify={(token, eKey) => self.handleVerificationSuccess(
                    token, eKey)}/>;
              } else {
                self.hCaptchaRef.current.resetCaptcha();
              }
              self.setState(self.state);
            }
            toast.error(response.message);
          }
        });
    } else {
      toast.error('Bitte Benutzername und Passwort eingeben!');
    }
  }

  async onKeyPressed(e) {
    if (e.key === 'Enter') {
      this.doOAuthAuthenticationRequest();
    }
  }

  onLoginClick(e) {
    this.doOAuthAuthenticationRequest(e);
  }

  openResetPasswordDialog() {
    this.setState({resetPasswordDialogOpen: true});
  }

  handleVerificationSuccess(token, ekey) {
    this.captchaToken = token;
  }

  render() {
    return <>
      <div className='md:bg-transparent flex items-center justify-center md:justify-end h-screen'>
        <div className='rounded-3xl md:rounded-3xl bg-cn-color-primary md:h-[400px] md:w-[260px] md:mr-14 relative w-full p-2 m-2'>
          <Card sx={{backgroundColor: '#fff', borderTopLeftRadius: '24px', borderTopRightRadius: '24px', borderBottomLeftRadius: '24px', borderBottomRightRadius: '24px'}} className='md:absolute md:right-10 md:top-10 md:min-w-[260px] md:min-h-[400px]'>
            <CardContent className={'text-cn-color-static-black'}>
              <p className="text-xs mt-12 uppercase text-cn-color-static-black">Bereits Kunde?</p>
              <p className="text-2xl uppercase text-cn-color-static-black">Anmelden</p>
              <div className='flex flex-col gap-3 mb-8 mt-2'>
                <InputText sx={{
                  "& .MuiInputBase-input": {
                    color: "#000", // Textfarbe im Eingabefeld
                  },
                  "& .MuiInput-underline:before": {
                    borderBottomColor: "#ccc", // Standardfarbe
                  },
                  "& .MuiInput-underline:after": {
                    borderBottomColor: "#222", // Fokus-Farbe
                  },
                  "& .MuiInput-underline:hover:before": {
                    borderBottomColor: "#bbb", // Hover-Farbe
                  }
                }} variant='standard' id='login' size='small' placeholder='E-Mail' autoFocus/>
                <div className='flex gap-3'>
                  <InputText sx={{
                    "& .MuiInputBase-input": {
                      color: "#000", // Textfarbe im Eingabefeld
                    },
                    "& .MuiInput-underline:before": {
                      borderBottomColor: "#ccc", // Standardfarbe
                    },
                    "& .MuiInput-underline:after": {
                      borderBottomColor: "#222", // Fokus-Farbe
                    },
                    "& .MuiInput-underline:hover:before": {
                      borderBottomColor: "#bbb", // Hover-Farbe
                    }
                  }} variant='standard' id="password" size='small' placeholder='Password' type='password' name='password'
                             onKeyDown={(event) => this.onKeyPressed(event)}/>
                  <IconButton onClick={(e) => this.onLoginClick(e)} sx={{
                    color: "#000",
                    "&:hover": {
                      backgroundColor: "#ccc",
                      borderRadius: '100%',
                    }
                  }}>
                    <ChevronRight className={'w-[30px] h-[30px]'}/>
                  </IconButton>
                </div>
              </div>
              <Button variant='text' onClick={(e) => this.openResetPasswordDialog(e)} sx={{
                color: "#000",
                "&:hover": {
                  color: "#777",
                }
              }}>
                Passwort vergessen?
              </Button>
              {this.state.hCaptcha}
            </CardContent>
          </Card>
        </div>
      </div>
      <RequestPasswordResetDialog
        isOpen={this.state.resetPasswordDialogOpen}
        onCloseButtonClick={(e) => this.setState({resetPasswordDialogOpen: false})}/>
    </>
  }
}

export default LoginForm;
